export function headerMv() {
  const mv = document.querySelector(".l-inta-mv");
  const header = document.getElementById("js-header-inta");
  const textEl = document.querySelector(".p-header-inta__text");

  const setTextBarHeight = () => {
    if (!textEl) return;
    const th = textEl.getBoundingClientRect().height;
    if (th > 0) {
      document.documentElement.style.setProperty(
        "--header-inta-text-height",
        `${Math.round(th * 1000) / 1000}px`
      );
    } else {
      document.documentElement.style.removeProperty("--header-inta-text-height");
    }
  };

  const schedule = () => {
    setTextBarHeight();
    requestAnimationFrame(setTextBarHeight);
  };

  if (textEl) {
    schedule();
    window.addEventListener("load", schedule, { once: true });
    const ro = new ResizeObserver(() => {
      setTextBarHeight();
    });
    ro.observe(textEl);
    window.addEventListener("resize", setTextBarHeight, { passive: true });
  }

  if (!mv || !header) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.classList.toggle("_is-active", !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(mv);
}
